<template>
  <Popup :ref="(el) => popup = el"
         class=""
         :title="$t('labels.deal_action_confirmation', {action: $t(`deals.action.refuse`)})"
         @onClose="hide"
  >
    <form class="cancel-form" v-if="deal">
      <div class="popup__content">
        <div class="radio-list">
          <div class="radio">
            <input v-model="form.reason" :value="DisputeReason.NO_PAYMENT" type="radio" name="reason" id="NO_PAYMENT">
            <label for="NO_PAYMENT">{{ $t(`dispute_reason.${DisputeReason.NO_PAYMENT}_out`) }}</label>
          </div>
          <div class="radio" v-if="deal?.status !== DealStatus.DISPUTE">
            <input v-model="form.reason" :value="DisputeReason.WAITING_CONFIRMATION" type="radio" name="reason" id="WAITING_CONFIRMATION">
            <label for="WAITING_CONFIRMATION">{{ $t(`dispute_reason.${DisputeReason.WAITING_CONFIRMATION}`) }}</label>
          </div>
          <div class="radio">
            <input v-model="form.reason" :value="DisputeReason.INVALID_REQUISITES" type="radio" name="reason" id="INVALID_REQUISITES">
            <label for="INVALID_REQUISITES">{{ $t(`dispute_reason.${DisputeReason.INVALID_REQUISITES}`) }}</label>
          </div>
          <div class="radio">
            <input v-model="form.reason" :value="DisputeReason.PAYOUT_BLACKLIST" type="radio" name="reason" id="PAYOUT_BLACKLIST">
            <label for="PAYOUT_BLACKLIST">{{ $t(`dispute_reason.${DisputeReason.PAYOUT_BLACKLIST}`) }}</label>
          </div>
          <div class="radio">
            <input v-model="form.reason" :value="DisputeReason.UNABLE_TO_PAY_OUT_ON_REQ" type="radio" name="reason" id="UNABLE_TO_PAY_OUT_ON_REQ">
            <label for="UNABLE_TO_PAY_OUT_ON_REQ">{{ $t(`dispute_reason.${DisputeReason.UNABLE_TO_PAY_OUT_ON_REQ}`) }}</label>
          </div>
          <div class="radio"  v-if="deal?.status !== DealStatus.DISPUTE">
            <input v-model="form.reason" :value="DisputeReason.PART_PAYOUT" type="radio" name="reason" id="PART_PAYOUT">
            <label for="PART_PAYOUT">{{ $t(`dispute_reason.${DisputeReason.PART_PAYOUT}`) }}</label>
          </div>
        </div>
      </div>
      <div v-if="[DisputeReason.INVALID_SUM, DisputeReason.PART_PAYOUT].includes(form.reason)" class="d-flex align-items-center gap-sm">
        <label for="amount" class="col-sm-4 col-form-label text-capitalize-first pe-2">{{ helper.trans("labels.sum") }}</label>
        <div class="col-sm-4">
          <FormInputWrapper v-slot="parentProps" :errors="getErrors(`disputeReasonData.amount`)" >
            <input v-model="form.amount"
                   :class="parentProps.class"
                   v-maska
                   data-maska="9.##"
                   data-maska-tokens="9:[0-9]:multiple"
                   type="text" class="form-control " id="amount">
          </FormInputWrapper>


        </div>
      </div>
      <form class="download-form" v-if="DisputeReason.PART_PAYOUT === form.reason">
        <div class="download-form__container" id="drop-area" v-bind="dropzone.getRootProps()">
          <input v-bind="dropzone.getInputProps()" />
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M35.25 33H25.5V18.6216L30.4397 23.5603C30.7233 23.8297 31.1009 23.9777 31.4921 23.9727C31.8832 23.9677 32.2569 23.8101 32.5335 23.5335C32.8101 23.2569 32.9677 22.8832 32.9727 22.492C32.9777 22.1009 32.8297 21.7233 32.5603 21.4397L25.0603 13.9397C24.779 13.6586 24.3977 13.5007 24 13.5007C23.6023 13.5007 23.221 13.6586 22.9397 13.9397L15.4397 21.4397C15.1703 21.7233 15.0223 22.1009 15.0273 22.492C15.0323 22.8832 15.1899 23.2569 15.4665 23.5335C15.7431 23.8101 16.1168 23.9677 16.508 23.9727C16.8991 23.9777 17.2767 23.8297 17.5603 23.5603L22.5 18.6216V33H12.75C11.3581 32.9985 10.0236 32.4449 9.03933 31.4607C8.05509 30.4764 7.50149 29.1419 7.5 27.75V8.25C7.50149 6.85807 8.05509 5.52358 9.03933 4.53933C10.0236 3.55509 11.3581 3.00149 12.75 3H35.25C36.6419 3.00149 37.9764 3.55509 38.9607 4.53933C39.9449 5.52358 40.4985 6.85807 40.5 8.25V27.75C40.4985 29.1419 39.9449 30.4764 38.9607 31.4607C37.9764 32.4449 36.6419 32.9985 35.25 33ZM25.5 43.5C25.5 43.8978 25.342 44.2794 25.0607 44.5607C24.7794 44.842 24.3978 45 24 45C23.6022 45 23.2206 44.842 22.9393 44.5607C22.658 44.2794 22.5 43.8978 22.5 43.5V33H25.5V43.5Z" fill="#77818D"></path>
          </svg>
          <div class="download-form__text" id="file-text">
            {{ $t('labels.payout_upload_files')}}
          </div>
        </div>
        <div v-for="fileAttachment in fileAttachments" class="row mb-2 ms-2" :key="fileAttachment.id">
          <div class="col-sm-12">
            <svg-icon class="icon icon__warning icon__small" icon="paperclip"/> <span class="me-2">{{ fileAttachment.file.name}}</span>
            <div v-if="fileAttachment.error === null && fileAttachment.attachment === null" class="spinner-border" role="status" style="zoom: 0.5">
              <span class="visually-hidden"></span>
            </div>
            <a v-else href="#" @click.prevent="removeFile(fileAttachment)">
              <svg-icon class="icon icon__attention icon__small" icon="xmark"/>
            </a>
            <div>
              <small class="text-danger" v-if="fileAttachment.error !== null">{{fileAttachment.error}}</small>
            </div>
          </div>
        </div>
      </form>
      <div class="popup__controls">
        <button type="button" @click="hide" class="btn popup__close">
          <span class="text-capitalize-first">{{ $t('button.cancel') }}</span>
        </button>
        <LoaderButton :on-click="refuse" class="btn btn--reset">
          <span class="text-capitalize-first">{{ $t('button.refuse') }}</span>
        </LoaderButton>
      </div>
    </form>

  </Popup>
</template>
<script lang="ts">
import {computed, defineComponent, ref} from 'vue'
import {reactive, toRefs} from '@vue/reactivity';
import Popup from "@/apps/public/components/Popup.vue";
import axios from "axios";
import {$t, helper} from "@/service/CommonHelper";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import { useStore } from 'vuex';
import { api } from '@/service/APIClient';
import LoaderContent from "@/apps/public/components/LoaderContent.vue";
import TraderDealDTO from "@/models/TraderDealDTO";
import {DisputeReason} from "@/models/enum/DisputeReason";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import AttachmentDTO from "@/models/AttachmentDTO";
import {DealStatus} from "@/models/enum/DealStatus";
import SvgIcon from "@/apps/public/components/SvgIcon.vue";
import {useDropzone} from "vue3-dropzone";
import {useNotification} from "@kyvg/vue3-notification";

interface AttachmentFileDTO {
  id: number;
  attachment: AttachmentDTO|null,
  file: File,
  error: string|null
}
let id = 0;
export default defineComponent({
  methods: {$t},
  components: {SvgIcon, LoaderContent, LoaderButton, FormInputWrapper, Popup},
  setup(props) {
    const notification = useNotification()
    const popup = ref<InstanceType<typeof Popup> | null>(null)
    const store = useStore()
    const state = reactive({
      deal: null as TraderDealDTO|null,
      onComplete: null as any,
      form: {
        reason: DisputeReason.NO_PAYMENT as DisputeReason,
        amount: '' as string
      },
      errors: {} as ValidationErrorDTO[]|any,
      fileAttachments: [] as AttachmentFileDTO[],
    });

    const getErrors = (path: string) => {
      if (!state.errors.hasOwnProperty(path)) {
        return [];
      }

      return state.errors[path]
    }

    const onDrop = async (acceptFiles: any, rejectReasons: any) => {
      for (const file of acceptFiles) {
        state.fileAttachments.push({
          id: id++,
          attachment: null,
          file,
          error: null
        } as AttachmentFileDTO)
      }

      for (const fileAttachment of state.fileAttachments) {
        try {
          fileAttachment.attachment = await api.attachmentsUpload(fileAttachment.file)
        } catch (e) {
          console.log(e);
          if (helper.isValidationErrors(e)) {
            for (const item of helper.getValidationErrors(e)) {
              notification.notify({type: 'error', title: helper.trans(`server_errors.${item.code}`, {}, item.message)});
            }
          } else {
            notification.notify({type: 'error', title: helper.trans(`server_errors.c8c7315c-6186-4719-8b71-5659e16bdcb7`)});
          }
          fileAttachment.error = helper.trans(`server_errors.c8c7315c-6186-4719-8b71-5659e16bdcb7`)
        }

      }
    }
    const dropzone = useDropzone({ onDrop });

    const removeFile = (fileAttachment: AttachmentFileDTO) => {
      state.fileAttachments = state.fileAttachments.filter((file) => file.id !== fileAttachment.id)
    }

    const setErrors = (data: ValidationErrorDTO[]) => {
      state.errors = {};
      for (const error of data) {
        if (!state.errors.hasOwnProperty(error.field)) {
          state.errors[error.field] = [];
        }
        state.errors[error.field].push(error)
      }
    }

    const getForm = () => {
      let data = {
        disputeReason: state.form.reason,
        disputeReasonData: {},
        attachments: state.fileAttachments.filter((file) => file.attachment !== null).map((file) => file.attachment!.id)
      }


      if ([DisputeReason.INVALID_SUM, DisputeReason.PART_PAYOUT].includes(state.form.reason)) {
        data.disputeReasonData = {
          amount: parseFloat(state.form.amount)
        }
      }

      return data;
    }

    const refuse = async () => {
      if (!state.deal) {
        return
      }

      try {
        await api.dealChangeStatus(state.deal?.id, 'refuse', getForm());
        hide()
        if (state.onComplete) {
          state.onComplete()
        }
      } catch (e) {
        if (helper.isValidationErrors(e)) {
          const errors = helper.getValidationErrors(e);
          for (const item of errors) {
            notification.notify({type: 'error', title: helper.trans(`server_errors.${item.code}`, {}, item.message)});
          }
          setErrors(errors)
        }

        console.log(e)
        throw e
      }
    }

    const show = (deal: TraderDealDTO, onComplete: any) => {
      popup.value?.show()
      state.deal = deal
      state.form.reason = DisputeReason.NO_PAYMENT
      state.form.amount = ''
      state.fileAttachments = []
      state.errors = []
      state.onComplete = onComplete
    }

    const hide = () => {
      popup.value?.hide()
    }

    return {
      ...toRefs(state),
      dropzone,
      removeFile,
      getErrors,
      DisputeReason,
      DealStatus,
      refuse,
      popup,
      helper,
      show,
      hide,
    }
  }
})
</script>
